<template>
  <CopyTrackWrapper
    type="sdi_strategy"
    :title="title"
    :text="copyText"
    class="strategy">
    <div class="title-wrapper">
      <h4>{{ title }}</h4>
      <tooltip
        :text="'Copy'"
        placement="bottom">
        <CopyButton
          btn-class="btn btn-default btn-xs borderless-button"
          :copy-text="copyText"
          success-text="Copied Strategy"
          error-text="Error copying text. Use Ctrl+C instead."
          :aria-label="`Copy ${title} strategy`"
          :tooltip-placement="'bottom'">
          <span
            class="material-icons-outlined borderless-button-content copy"
            :aria-label="`Copy ${title} strategy`">
            content_copy
          </span>
        </CopyButton>
      </tooltip>
    </div>
    <p
      ref="strategyText">
      {{ strategyTextDisplay }}
      <button
        @click="toggleExpanded()"
        class="link-button">
        {{ expanded ? 'see less' : 'read more' }}
      </button>
    </p>
    <FeedbackButtons :event-data="feedbackEventData" />
  </CopyTrackWrapper>
</template>

<script>
import CopyTrackWrapper from '@/components/CopyTrackWrapper.vue'
import CopyButton from '@/components/CopyButton.vue'
import FeedbackButtons from '@/components/FeedbackButtons.vue';

export default {
  name: 'SDIStrategyCard',
  components: {FeedbackButtons, CopyButton, CopyTrackWrapper },
  data() {
    return {
      expanded: false,
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    guideline: {
      type: String,
      default: ''
    },
    traceID: {
      type: String,
      default: ''
    }
  },
  computed: {
    strategyTextDisplay() {
      if (this.expanded) {
        return this.description
      }
      return `${this.description.substring(0, 175)} ...`
    },
    copyText() {
      return `${this.title}\n\n${this.description}`
    },
    feedbackEventData() {
      return {
        sdi_strategy_description: this.description,
        sdi_udl_guideline: this.guideline,
        sdi_strategy_title: this.title,
        sdi_trace: this.traceID
      }
    }
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
    },
  }
}
</script>

<style scoped lang='less'>
@import '~@/variables.less';
h4 {
  display: inline;
  font-weight: bold;
  font-size: 1.125rem;
}
.strategy {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  p {
    font-size: 1.125rem;
    line-height: 1.55em;
    margin-bottom: var(--spacing-lg);
  }
}
</style>
